import { initAll } from 'govuk-frontend/dist/govuk/govuk-frontend.min.js';
import HMRCFrontend from './all';

initAll();
HMRCFrontend.initAll();
